var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        getA: _vm.getA,
        setA: _vm.setA,
        getB: _vm.getB,
        setB: _vm.setB,
        getC: _vm.getC,
        setC: _vm.setC,
        getD: _vm.getD,
        setD: _vm.setD,
        getE: _vm.getE,
        setE: _vm.setE,
        setisF: _vm.setisF,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        getA,\n        setA,\n        getB,\n        setB,\n        getC,\n        setC,\n        getD,\n        setD,\n        getE,\n        setE,\n        setisF,\n      }"}],attrs:{"id":"fan"}},[_c('img',{attrs:{"src":require("../assets/img/fan/1.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        getA: _vm.getA,
        setA: _vm.setA,
        getB: _vm.getB,
        setB: _vm.setB,
        getC: _vm.getC,
        setC: _vm.setC,
        getD: _vm.getD,
        setD: _vm.setD,
        getE: _vm.getE,
        setE: _vm.setE,
        setisF: _vm.setisF,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        getA,\n        setA,\n        getB,\n        setB,\n        getC,\n        setC,\n        getD,\n        setD,\n        getE,\n        setE,\n        setisF,\n      }"}],attrs:{"id":"motor"}},[_c('img',{attrs:{"src":require("../assets/img/fan/2.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        getA: _vm.getA,
        setA: _vm.setA,
        getB: _vm.getB,
        setB: _vm.setB,
        getC: _vm.getC,
        setC: _vm.setC,
        getD: _vm.getD,
        setD: _vm.setD,
        getE: _vm.getE,
        setE: _vm.setE,
        setisF: _vm.setisF,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        getA,\n        setA,\n        getB,\n        setB,\n        getC,\n        setC,\n        getD,\n        setD,\n        getE,\n        setE,\n        setisF,\n      }"}],attrs:{"id":"base"}},[_c('img',{attrs:{"src":require("../assets/img/fan/3.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        getA: _vm.getA,
        setA: _vm.setA,
        getB: _vm.getB,
        setB: _vm.setB,
        getC: _vm.getC,
        setC: _vm.setC,
        getD: _vm.getD,
        setD: _vm.setD,
        getE: _vm.getE,
        setE: _vm.setE,
        setisF: _vm.setisF,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        getA,\n        setA,\n        getB,\n        setB,\n        getC,\n        setC,\n        getD,\n        setD,\n        getE,\n        setE,\n        setisF,\n      }"}],attrs:{"id":"a4"}},[_c('img',{attrs:{"src":require("../assets/img/fan/4.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        getA: _vm.getA,
        setA: _vm.setA,
        getB: _vm.getB,
        setB: _vm.setB,
        getC: _vm.getC,
        setC: _vm.setC,
        getD: _vm.getD,
        setD: _vm.setD,
        getE: _vm.getE,
        setE: _vm.setE,
        setisF: _vm.setisF,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        getA,\n        setA,\n        getB,\n        setB,\n        getC,\n        setC,\n        getD,\n        setD,\n        getE,\n        setE,\n        setisF,\n      }"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/fan/5.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
        go: _vm.go,
        setPan: _vm.setPan,
        getPan: _vm.getPan,
        getA: _vm.getA,
        setA: _vm.setA,
        getB: _vm.getB,
        setB: _vm.setB,
        getC: _vm.getC,
        setC: _vm.setC,
        getD: _vm.getD,
        setD: _vm.setD,
        getE: _vm.getE,
        setE: _vm.setE,
        setisF: _vm.setisF,
      }),expression:"{\n        go,\n        setPan,\n        getPan,\n        getA,\n        setA,\n        getB,\n        setB,\n        getC,\n        setC,\n        getD,\n        setD,\n        getE,\n        setE,\n        setisF,\n      }"}],attrs:{"id":"line"}},[_c('img',{attrs:{"src":require("../assets/img/fan/6.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","bottom":"5%","display":"flex","left":"50%","transform":"translateX(-50%)"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isF),expression:"isF"}],staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('div',{staticClass:"button dark",staticStyle:{"margin-left":"20px"},on:{"click":function($event){return _vm.goto('/fans')}}},[_vm._v("\n      进入体验页\n    ")])]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/fan/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456d2c78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fan.vue
// module id = null
// module chunks = 